/* @flow */
import React, { StatelessFunctionalComponent } from 'react';
import { observer } from 'mobx-react';
import VirtualizedSelect from 'react-virtualized-select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import styles from '../ElectroSelectExtra/ElectroSelectExtra.module.scss';
import electroSelectStyles from '../ElectroSelect/ElectroSelect.module.scss';

/**
 * Basic select for fields that only need to render field.extra.options data
 */
const ElectroSimpleSelect: React<StatelessFunctionalComponent> = ({
  field,
  value,
  disabled,
  isFlex,
}: Object) => {
  const isFocusedClass: string = field.isFocused ? electroSelectStyles['is-focused'] : '';
  const isErrorClass: string = field.error ? electroSelectStyles['is-error'] : '';
  const isDisabledClass: string = disabled ? electroSelectStyles['is-disabled'] : '';
  const isFlexClass: string = isFlex ? styles['is-flex'] : '';
  const isRequired: boolean = Boolean(field.rules && field.rules.includes('required'));

  const setResult = (_value: Object) => {
    field.set('value', _value.name || null);
  };

  return (
    <React.Fragment>
      <div className={`${styles['select-wrapper']} ${isFlexClass}`}>
        <div
          className={`${
            electroSelectStyles['electro-select']
          } ${isFocusedClass} ${isErrorClass} ${isDisabledClass}`}
        >
          <FormControl>
            <InputLabel
              className={electroSelectStyles['custom-placeholder']}
              required={isRequired}
              shrink={Boolean(field.value)}
            >
              {field.label}
            </InputLabel>
            <VirtualizedSelect
              {...field.bind()}
              arrowRenderer={() =>
                !disabled && (
                  <svg className={electroSelectStyles['dropdown-icon']}>
                    <use xlinkHref="#icon-drop-arrow-down" />
                  </svg>
                )
              }
              name={field.name}
              placeholder={null}
              clearable={false}
              searchable
              multi={false}
              className={electroSelectStyles['electro-select-field']}
              helperText={field.showError ? field.error : ''}
              required={isRequired}
              options={field.extra.options}
              onChange={(selectedValue: Object) => setResult(selectedValue)}
              value={value || field.value || null}
              labelKey="name"
              valueKey="name"
              disabled={disabled}
            />
          </FormControl>
        </div>
      </div>
    </React.Fragment>
  );
};

export default observer(ElectroSimpleSelect);
